import {
  WorkOrder,
  updateState,
} from "@/services/backend/htz/work-order/types/work-order";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import t from "@/lang/lang";
import { CommonDialogFooter } from "@/shared/components/dialog/dialog-common";
import { useHtzWorkOrderPutMutation } from "@/services/backend/htz/work-order/api/work-order-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { FulfillmentState } from "@/services/backend/relationships/types/fulfillment";
import { useEffect, useState } from "react";

export function CompleteWorkOrderDialog({
  workOrder,
}: {
  workOrder: WorkOrder;
}) {
  const [open, setOpen] = useState(false);
  const [put, { isLoading, error, isSuccess, reset }] =
    useHtzWorkOrderPutMutation();

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
      reset();
    }
  }, [isSuccess, reset]);

  const doForward = () => {
    if (isLoading) return;

    put(updateState(workOrder, FulfillmentState.Completed));
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button>{t("Fertigstellen")}</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Arbeitsschein fertigstellen?")}</DialogTitle>
          <DialogDescription>
            {t(
              'Der Arbeitsschein wird als "Erledigt" markiert. Damit ist er zur Rechnungsstellung freigegeben.',
            )}
          </DialogDescription>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} ignoreValidationError={false} />
        <CommonDialogFooter isLoading={isLoading} onClickAction={doForward} />
      </DialogContent>
    </Dialog>
  );
}
